import React, { useState, useEffect } from 'react';
import { Stack, Box } from "@mui/material"
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import dayjs from "dayjs";
import { Line } from 'react-chartjs-2';
import { useEjes } from '../hooks/useEjes'
import { useColors } from '../hooks/useColors'
import { AllCalificationsWithImageAndText } from './AllCalificationsWithImageAndText'

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

var yLabels = {
    25: 'D',
    50: 'C',
    75: 'B',
    100: 'A',
}

export const LineChart = ({ cuestionarios }) => {

    const { getCalificationColor } = useColors()
    const [dataSets, setdataSets] = useState([])
    const { ejes } = useEjes()

    const options = {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: false,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                min: -2,
                max: 102,
                ticks: {
                    stepSize: 25,
                    callback: function (value, index, values) {
                        return '';
                    },
                    color: [getCalificationColor('D'), getCalificationColor('C'), getCalificationColor('B'), getCalificationColor('A')],
                    font: {
                        size: 25,
                    }
                },
            },
        }
    };

    // const config = {
    //     type: 'line',
    //     options: {
    //       responsive: true,
    //       plugins: {
    //         legend: {
    //           position: 'top',
    //         },
    //         title: {
    //           display: true,
    //           text: 'Chart.js Line Chart'
    //         }
    //       }
    //     },
    //   };

    function strToArray(str, limit) {
        const words = str?.split(' ')
        let aux = []
        let concat = []

        for (let i = 0; i < words?.length; i++) {
            concat.push(words[i])
            let join = concat.join(' ')
            if (join.length > limit) {
                aux.push(join)
                concat = []
            }
        }

        if (concat.length) {
            aux.push(concat.join(' ').trim())
        }

        return aux
    }

    useEffect(() => {
        var ds = []
        cuestionarios.map(c => (
            ds = [...ds, {
                label: dayjs(c.fecha_fin).format("DD/MM/YYYY"),
                data: c.puntuacionEjes.map((puntuacionEje) => puntuacionEje.puntuacion),
                borderColor: getCalificationColor(c.calificacion),
                backgroundColor: getCalificationColor(c.calificacion)
            }]
        ))
        setdataSets(ds)

    }, [cuestionarios])

    const data = {
        labels: ejes ? (ejes.map(t => strToArray(t.texto, 10))) : (null),
        datasets: dataSets,
    };

    // Función para detectar móviles y tabletas
    const isMobileOrTablet = () => {
        return (window.innerWidth <= 1200);
    };

    // Estilos condicionales
    const lineStyle = isMobileOrTablet() ? { width: '1200px' } : {};

    return (
        <Stack direction="row" height="400px" sx={{ overflow: { xs: 'scroll', lg: 'hidden' } }}>
            <AllCalificationsWithImageAndText width={40} flex={1} grafico={true} />
            <Box flex={{ md: 6, lg: 7 }} width={{ xs: '1000px', md: 'auto' }} marginTop={3} marginLeft={-5}>
                <Line style={lineStyle} options={options} data={data} />
            </Box>
        </Stack>
    )
}

